import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaKeyValue'

type IcaKeyValueProps = React.JSX.IntrinsicElements['tgdb-ica-key-value']

export const IcaKeyValue = wrapWc<IcaKeyValueProps>('tgdb-ica-key-value', [])